var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-page-loading"},[_c('div',{staticClass:"full-page-loading-spin"},[_c('a-spin',{attrs:{"size":"large","tip":_vm.text}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }